// extracted by mini-css-extract-plugin
export var deleteIcon = "_te-5";
export var deleteOption = "_te-3";
export var divider = "_te-2";
export var downloadIcon = "_te-4";
export var drawer = "_te-0";
export var drawerFooter = "_te-6";
export var drawerOpen = "_te-1";
export var highlighted = "_te-7";
export var lighterHighlight = "_te-8";